import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdatePeepWidgets as UpdatePeepWidgetsMutation,
    UpdatePeepWidgetsVariables,
    WidgetEntityTypeUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_PEEP_WIDGETS from '../mutations/update-peep-widgets.graphql';

export const useUpdatePeepWidgets = (): {
    updatePeepWidgets: (arg1: WidgetEntityTypeUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updatePeepWidgets, {loading, error}] = useMutation<
        UpdatePeepWidgetsMutation,
        UpdatePeepWidgetsVariables
    >(UPDATE_PEEP_WIDGETS);

    return {
        updatePeepWidgets: (input: WidgetEntityTypeUpdateInput) =>
            updatePeepWidgets({
                variables: {input},
                refetchQueries: ['GetPeepWidgets'],
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
